import React, { useEffect, useState, useCallback } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Card, Col, Row, Table, Dropdown, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getToken, getUserId } from '../services/authorize';
import axiosInstance from "../services/axiosInterceptor";
import { useLoading } from '../contexts/LoadingContext';

export default function StudentGradeList() {
  const { setLoading } = useLoading();
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead');
      if (skin === 'dark') {
        for (const thead of theads) { thead.classList.remove('table-secondary'); thead.classList.add('table-primary'); }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) { thead.classList.remove('table-primary'); thead.classList.add('table-secondary'); }
      }
    }
  };
  switchSkin(skin);
  useEffect(() => { switchSkin(skin); }, [skin]);

  const [yearList, setYearList]         = useState([]);
  const [yearId, setYearId]             = useState(() => localStorage.getItem('yearId') || null);
  const [selectedYear, setSelectedYear] = useState('');
  const [data, setData]                 = useState([]);

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`, {
      headers: { authorization: `Bearer ${getToken()}` }
    })
    .then(res => {
      const list = res.data;
      setYearList(list);
      let id = localStorage.getItem('yearId');
      if (!id && list.length > 0) { id = list[0].year_id; localStorage.setItem('yearId', id); }
      setYearId(id);
      const found = list.find(y => String(y.year_id) === String(id));
      if (found) setSelectedYear(`ปีการศึกษา ${found.year_year}`);
    })
    .catch(() => {});
  }, []);

  const loadData = useCallback(() => {
    if (!yearId) return;
    setLoading(true);
    axiosInstance.get(
      `${process.env.REACT_APP_API}/getStudentsByAdvisorRoom/${getUserId()}/${yearId}`,
      { headers: { Authorization: `Bearer ${getToken()}` } }
    )
    .then(res => setData(res.data))
    .catch(() => setData([]))
    .finally(() => setLoading(false));
  }, [yearId, setLoading]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleSelectYear = (id) => {
    const found = yearList.find(y => y.year_id === id);
    if (found) {
      setYearId(id);
      setSelectedYear(`ปีการศึกษา ${found.year_year}`);
      localStorage.setItem('yearId', id);
    }
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">ที่ปรึกษาห้องเรียน</Link></li>
              <li className="breadcrumb-item active">ผลการเรียนรายบุคคล</li>
            </ol>
            <h4 className="main-title mb-0">ผลการเรียนรายบุคคล</h4>
          </div>
          <div className="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <Dropdown>
              <Dropdown.Toggle variant="primary" id="dropdown-year">
                {selectedYear || 'เลือกปีการศึกษา'}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {yearList.map(y => (
                  <Dropdown.Item key={y.year_id} onClick={() => handleSelectYear(y.year_id)}>
                    ปีการศึกษา {y.year_year}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <Row className="g-3">
          <Col xl="12">
            <Card className="card-one">
              <Card.Header>
                <Card.Title as="h6">{selectedYear}</Card.Title>
              </Card.Header>
              <Card.Body className="p-3">
                <Table responsive hover className="mb-0">
                  <thead>
                    <tr>
                      <th className="text-center" style={{ width: 50 }}>ที่</th>
                      <th className="text-center" style={{ width: 110 }}>เลขประจำตัว</th>
                      <th>ชื่อ-สกุล</th>
                      <th className="text-center" style={{ width: 120 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? data.map((s, i) => (
                      <tr key={s.study_id} className={s.st_status === '0' ? 'table-danger' : ''}>
                        <td className="text-center">{i + 1}</td>
                        <td className="text-center">{s.st_idnumber}</td>
                        <td>
                          {s.st_name}
                          {s.st_status === '0' && (
                            <Badge bg="danger" className="ms-2">พ้นสภาพ</Badge>
                          )}
                        </td>
                        <td className="text-center">
                          <Link to={`/advisor/student-grade/${s.study_id}/${yearId}`}>
                            <i className="ri-eye-line"></i> ดูผลการเรียน
                          </Link>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={4} className="text-center text-muted py-4">ไม่พบข้อมูลนักเรียน</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
